export default __webpack_public_path__ + "static/media/elevate-swarovski-poster-1.3f44317a.jpg";